// 顺序不能乱 要跟治疗表 和 模型 那里的顺序一致
const A_Dict = {
    curePlanDict: [
        "主诉",
        "主要矫治目标",
        "临床状况",
        "拟矫治牙颌",
        "牙齿信息",
        "不可移动牙齿",
        "不可设计附件牙齿",
        "矢状关系",
        "覆盖",
        "覆合",
        "前牙反合/对刃合",
        "后牙反合或锁合",
        "中线",
        "间隙的矫治",
        "拥挤的矫治",
        "是否配合种植支抗钉",
        "是否需要引力扣",
        "颞下关节是否存在异常",
        "是否需要被动矫治器",
        "特殊说明"
    ],
    picModalDict: ["CBCT", "牙颌模型", "面像及口内照片", "X光片", "其他影像资料"]
};
const E_Dict = {
    curePlanDict: [
        "主诉",
        "主要矫治目标",
        "临床状况",
        "拟矫治牙颌",
        "牙齿信息",
        "不可移动牙齿",
        "不可设计附件牙齿",
        "矢状关系",
        "覆盖",
        "覆合",
        "前牙反合/对刃合",
        "后牙反合或锁合",
        "中线",
        "间隙的矫治",
        "拥挤的矫治",
        "是否配合种植支抗钉",
        "是否需要引力扣",
        "颞下颌关节是否存在异常",
        "是否需要被动矫治器",
        "修复设计",
        "特殊说明"
    ],
    picModalDict: ["CBCT", "牙颌模型", "面像及口内照片", "X光片", "其他影像资料"]
};
const I_Dict = {
    curePlanDict: [
        "主诉",
        "主要矫治目标",
        "拟矫治牙颌",
        "牙齿信息",
        "不可移动牙齿",
        "不可设计附件牙齿",
        "间隙的矫治",
        "是否需要引力扣",
        "是否需要被动矫治器",
        "特殊说明"
    ],
    picModalDict: ["CBCT", "牙颌模型", "面像及口内照片", "X光片", "其他影像资料"]
};

export {A_Dict, E_Dict, I_Dict};
